import { createFileRoute, Link, Navigate } from '@tanstack/react-router';

import { OutreachTemplatesCard } from '@apps/web/components/settings/outreach_templates_card';
import { PlanOfCareDutyMonitoringCard } from '@apps/web/components/settings/plan_of_care_duty_monitoring_card';
import {
    SettingsPageShell,
    useSettingsGates,
} from '@apps/web/features/settings';

export const Route = createFileRoute('/_app/settings/clock-in-out')({
    component: ClockInOutPage,
});

function ClockInOutPage() {
    const { organizationId, gates, planOfCareDutyMonitoringAvailable } =
        useSettingsGates();
    if (!gates.canManageOrgSettings) {
        return <Navigate to="/settings" replace={true} />;
    }
    if (organizationId === null) {
        return null;
    }

    return (
        <SettingsPageShell
            title="Clock in / Clock out"
            description="Control clock reminder outreach settings."
        >
            <OutreachTemplatesCard
                organizationId={organizationId}
                outreachTypes={
                    planOfCareDutyMonitoringAvailable
                        ? ['clock_in', 'clock_out', 'plan_of_care_duties']
                        : ['clock_in', 'clock_out']
                }
                outreachTypeSettings={
                    planOfCareDutyMonitoringAvailable
                        ? {
                              plan_of_care_duties: (
                                  <PlanOfCareDutyMonitoringCard
                                      organizationId={organizationId}
                                  />
                              ),
                          }
                        : undefined
                }
                title="Clock reminder templates"
                description="Configure SMS templates and delays for clock-in and clock-out reminders."
                variant="embedded"
                headerAction={
                    <Link
                        to="/settings/skip-allow-lists"
                        className="text-foreground text-sm font-medium whitespace-nowrap hover:underline"
                    >
                        Manage skip lists →
                    </Link>
                }
            />
        </SettingsPageShell>
    );
}
